import { fetchCustomSellerOrdersByEmail } from '../../api/orders/shared';
import { showError } from '../../util/errorPopupUtil';
import { setLoading } from '../index';
import { setOrders } from './OrdersSearchActions';
import { CloudFunctionRequestError } from '@asurion-core/frontend-utils/lib/ErrorsModule/ErrorsModule';

export const getOrderByCustomSellerEmail = (simplrAccountId, email) => {
  return async function (dispatch) {
    try {
      const { orders } = await fetchCustomSellerOrdersByEmail(simplrAccountId, email);
      dispatch(setOrders(orders));
      dispatch(setLoading(false, 'searchPage'));
    } catch (e) {
      dispatch(setLoading(false, 'searchPage'));
      if (e instanceof CloudFunctionRequestError) {
        showError(e);
      } else {
        throw e;
      }
    }
  };
};
